/**
 * The smallest increment an input accepts for `precision` decimal places (0 -> 1, 2 -> 0.01).
 *
 * @param precision - the allowed decimal places
 * @returns the HTML number-input `step` for that precision
 */
export const precisionStep = (precision: number): number => 1 / Math.pow(10, precision)
